import qs from 'qs';

const fetchWindowParams = () => qs.parse(window.location.search.substring(1));

const addTrackingParams = (url: string): string => {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  const { tracking_id = null, tracking_origin = null } = fetchWindowParams();

  if (tracking_id === null || tracking_origin === null) {
    return url;
  }

  const urlObj = new URL(url);
  const urlParams = qs.parse(urlObj.search.substring(1));
  const trackingParams = { tracking_id, tracking_origin };
  const allParams = Object.assign({}, urlParams, trackingParams);
  urlObj.search = qs.stringify(allParams);

  return urlObj.toString();
};

export default addTrackingParams;
